module.exports = __webpack_public_path__ + "static/media/igloo.b17bec52.svg";